<template>
    <div>
        <div>
            <el-select v-model="work_type" @change="handleSelect" slot="prepend" placeholder=" please choose "
                style="margin-left: 10px; margin-right: 5px;">
                <el-option label="Body" value="1"></el-option>
                <el-option label="Face" value="2"></el-option>
            </el-select>
            <el-input placeholder="Please enter infoID" v-model="infoID" suffix-icon="el-icon-search" clearable
                style="width:300px;">
            </el-input>
            <el-date-picker style="margin-left:5px" v-model="date" type="daterange" range-separator="to"
                start-placeholder="start date" end-placeholder="end date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-button style="margin-left :10px" type="primary">search</el-button>
        </div>
        <div style="padding-top:5px;padding-bottom :10px ; padding-top : 10px;">
            <el-button style="margin-left : 10px " type="primary" icon="el-icon-upload2">Export</el-button>
        </div>
        <!--脸磁表：  -->
        <div>
            <el-table v-if="!this.showTable" :data="faceData" border style="width:100%">
                <el-table-column type="selection" width="70">
                </el-table-column>
                <el-table-column prop="userInfoID" label="InfoID" width="70" align="center">
                </el-table-column>
                <el-table-column label="position" width="100" align="center">
                    <template slot-scope="scope">
                        <img :src="getClsFacePartImage(scope.row)" alt="position" style="width: 75px;height: 75px; padding; 0% ; margin: 0%;" >
                    </template>
                </el-table-column>
                <el-table-column label="L_Fhd" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png" >
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.L_forehead_current + ' %' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope ="scope">
                            {{ scope.row.L_forehead_radio + ' %' }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="R_Fhd" width="150" align="center">
                    <el-table-column label="" width="55">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_forehead_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_forehead_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="L_Face" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_face_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_face_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="R_Face" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_face_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_face_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="L_Eye" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_eye_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_eye_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="R_Eye" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_eye_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_eye_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="L_Jaw" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_jaw_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_jaw_radio +' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="R_Jaw" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_jaw_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_jaw_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="L_Back" width="150" align="center">
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_back_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55" align="center">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.L_back_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="R_Back" width="150" align="center">
                    <el-table-column label="" width="55">
                        <template #header>
                            <img src="../images/current.png">
                        </template>
                        <template slot-scope="scope"> 
                            {{scope.row.R_back_current+' %'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="55">
                        <template #header>
                            <img src="../images/frequency.png">
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.R_back_radio+' %'}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="icf" label="EnergyMode" width="100" align="center"></el-table-column>
                <el-table-column prop="work_duration_face" label="Timer" width="100" align="center"></el-table-column>
                <el-table-column prop="work_date_face" label="Date" width="160" align="center"></el-table-column>
            </el-table>
        </div>
        <div>
            <el-table v-if="this.showTable" :data="cl4Data" border style="widows: 100%;">
                <el-table-column type="selection" width="70"></el-table-column>
                <el-table-column prop="userInfoID" label="InfoID" width="100" align="center"></el-table-column>
                <el-table-column label="position1" width="100" align="center" style="padding:0%">
                    <template slot-scope="scope">
                        <img :src="getClsPartImage(scope.row)" alt="部位图片" style="width: 75px; height: 75px; padding: 0%;margin: 0%;">
                    </template>
                </el-table-column>
                <el-table-column label="position2" width="100" align="center" style="padding:0%">
                    <template slot-scope="scope">
                        <img :src="getClsPart2Image(scope.row)" alt="部位图片" style="width: 75px; height: 75px; padding: 0%;margin: 0%;">
                    </template>
                </el-table-column>
                <el-table-column label="P1/P2" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.p12_mode + ' %' }}
                    </template>
                </el-table-column>
                <el-table-column label="P3/P4" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.p34_mode + ' %' }}
                    </template>
                </el-table-column>
                <el-table-column label="RF1/RF2" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.rf12_mode + " %" }}
                    </template>
                </el-table-column>
                <el-table-column label="RF3/RF4" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.rf34_mode + " %" }}
                    </template>
                </el-table-column>
                <el-table-column label="F1" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mode_f1 + " HZ" }}
                    </template>
                </el-table-column>
                <el-table-column label="F2" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mode_f2 + " HZ" }}
                    </template>
                </el-table-column>
                <el-table-column label="F3" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mode_f3 + " HZ" }}
                    </template>
                </el-table-column>
                <el-table-column label="operating hours" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.work_duration }}
                    </template>
                </el-table-column>
                <el-table-column prop="work_date" label="Creation date">
                </el-table-column>
            </el-table>
        </div>
        <div style="padding:10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" 
                :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
export default {
    data() {
        return {
            // 面包屑 ： 
            breadcrumb_teb:{},
            showTable: true,  // 控制表格的显示     true  : cl4  , false : face
            infoID: '',
            // 设置时间控件的值
            date: [],
            // 默认CL4
            work_type: "1",
            // 表格数据 ：
            cl4Data: [],
            faceData: [],
            pageNum: 1,
            // 页码
            pageSize: 10,
            // 总数据数
            total: 0,
            // 时间    
            date:[],
            //开始时间。
            firstDate:'',
            lastDate :'',
            // 获取全局变量：
            userID: this.$store.state.teb.cl4UserID,
            machine: this.$store.state.teb.machineID,
        };
    },
    methods: {
        // 模式选择：
        handleSelect(value) {
            console.log("Select values" + this.showTable)
            if (value == 1) {
                this.showTable = true;
            }
            else if (value == 2) {
                this.showTable = false;
            }
            this.load();
        },
        // 执行搜索
        search(){
            this.pageNum = 1 ;
            this.load();
        },
        // 初始化数据 （获取数据）
        load(){
            // 如果设置了时间 则
            if(this.date && this.date.length >0) {
                if(this.date[0] && this.date[1]) {
                    this.firstDate = this.date[0];
                    this.lastDate = this.date[2]
                }else{
                    this.firstDate = '';
                    this.lastDate = '';
                }
            }
            else {
                this.firstDate = "";
                this.lastDate = "";
            }
            request.get("/cl4user/selectToUserInfoFace",{
                params:{
                    machine : this.machine,
                    userID  : this.userID,
                    infoID  : this.infoID,
                    type    : this.work_type,
                    firstDate : this.firstDate,
                    lastDate  : this.lastDate,
                    pageNum  : this.pageNum,
                    pageSize : this.pageSize
                }
            }).then(res =>{
                console.log("获取数据：" );
                console.log(res.data)
                if(this.work_type ==='1'){
                    this.cl4Data = res.data
                    this.total = res.count
                }
                else if (this.work_type === '2'){
                    this.faceData = res.data
                    this.total = res.count
                }
            })
        },
        // 切页时：
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.load();
        },
        //
        handleSelectionChange(val){
            this.multipleSelection = val
        },
        handleCurrentChange(pageNum){
            this.pageNum = pageNum;
            this.load();
        },
        getClsPartImage(row){
            if(this.$store.state.teb.cls_gender == 0){
                if(row.body_part>9){
                    row.body_part = row.body_part - 10;
                }
                return require(`@/assets/positionImg/cl4FasePosition/q${row.body_part}.png`)
            }
                if(row.body_part>9){
                    row.body_part = row.body_part - 10;
                }
            return require(`@/assets/positionImg/cl4FasePosition/p${row.body_part}.png`)
        },
        getClsPart2Image(row){
            if(this.$store.state.teb.cls_gender == 0){
                if(row.body_part_>9){
                    row.body_part_ = row.body_part_ - 10;
                }
                return require(`@/assets/positionImg/cl4FasePosition/q${row.body_part_}.png`)
            }
                if(row.body_part_>9){
                    row.body_part_ = row.body_part_ - 10;
                }
            return require(`@/assets/positionImg/cl4FasePosition/p${row.body_part_}.png`)
        },
        getClsFacePartImage(row){
            console.log("  gender : "+this.$store.state.teb.cls_gender)
            if(this.$store.state.teb.cls_gender == 0){
                return require(`@/assets/positionImg/FacePosition/men_zheng.png`)
            }
            else{
                return require(`@/assets/positionImg/FacePosition/women_zheng.png`)

            }
        }
    },
    // 初次进入这个界面。
    created(){
        // 初始化 数据：
        this.load();
        // 面包屑初始化：
        this.breadcrumb_teb.name = 'cl4Face_userinfo'
        this.breadcrumb_teb.pageFlag = 3 
        this.breadcrumb_teb.machine = this.machine
        this.breadcrumb_teb.path = '/cl4Faceuserinfo'
        // 调用 全局函数 ： updateSecondTab   :: 
        this.$store.commit('updateSecondTab' , this.breadcrumb_teb)        

    },
    
}

</script>